/**
 * 数美风控
 * getDeviceId   用来设置 head 中 x-att-deviceid 的值
 * @author lianghua.fu
 * @date 2019-08-05 17:40:51
 */
$.module('MM.util.shumei', function () {
  function _init() {
    if (window.SMSdk) {
      return;
    }
    window._smReadyFuncs = [];
    window.SMSdk = {
      ready: function (fn) {
        fn && _smReadyFuncs.push(fn);
      },
    };
    window._smConf = {
      organization: '7tqUvUD6Zv1VRxWo2PGN', //传入 organization，不要传入 accessKey.
      staticHost: 'static.fengkongcloud.com',
    };
    var url = (function () {
      var originHost = 'static2.fengkongcloud.com';
      var isHttps = 'https:' === document.location.protocol;
      var protocol = isHttps ? 'https://' : 'http://';
      var fpJsPath = '/fpv2.js';
      var url = protocol + _smConf.staticHost + fpJsPath;
      var ua = navigator.userAgent.toLowerCase();
      var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
      var isLowIE = /msie\s[678]\.0/.test(ua);
      if (isHttps && isWinXP && isLowIE) {
        url = protocol + originHost + fpJsPath;
      }
      return url;
    })();
    var sm = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    sm.src = url;
    s.parentNode.insertBefore(sm, s);
  }

  /**
   * 获取数美 deviceId
   * @param cb
   */
  function getDeviceId(cb) {
    _init();

    var smTimeoutTime = 100;
    var smDeviceId = '';
    var smDeviceIdReady = false;
    var smTimer = setTimeout(function () {
      smDeviceId = SMSdk.getDeviceId ? SMSdk.getDeviceId() : smDeviceId;
      if (!smDeviceIdReady) {
        smDeviceIdReady = true;
        MM.core.debug('shumei deviceId:', smDeviceId);
        //执行业务逻辑
        cb && cb(smDeviceId);
      }
    }, smTimeoutTime);
    SMSdk.ready(function () {
      smDeviceId = SMSdk.getDeviceId ? SMSdk.getDeviceId() : smDeviceId;
      clearTimeout(smTimer);
      if (!smDeviceIdReady) {
        smDeviceIdReady = true;
        //执行业务逻辑
        MM.core.debug('shumei ready deviceId:', smDeviceId);
        cb && cb(smDeviceId);
      }
    });
  }

  return {
    getDeviceId: getDeviceId,
  };
});
